"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Fax = _ref => {
  let {
    title = 'Fax',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "8",
    y: "3",
    width: "12",
    height: "4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19,8H7v9h1v4h12v-4h2v-6C22,9.3,20.7,8,19,8z M13,9.5h2v1.2h-2V9.5z M13,11.5h2v1.2h-2V11.5z M10,9.5h2v1.2h-2V9.5z M10,11.5h2v1.2h-2V11.5z M18,19h-8v-5h8V19z M18,12.7h-2v-1.2h2V12.7z M18,10.7h-2V9.5h2V10.7z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0,0h24v24H0V0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5,18v-7.5L6,11V8H5c-1.7,0-3,1.3-3,3v1v5v1c0,1.7,1.3,3,3,3h1v-3.5L5,18z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Fax);
Fax.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Fax",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Fax'",
        "computed": false
      },
      "required": false
    }
  }
};